/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileXlsShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586zM18 20v-1h2v3H8v-2z" />
        <path d="m9.616 17 1.5-2.526L9.69 12.13h1.2l1.005 1.682.978-1.682h1.152l-1.434 2.365L14.098 17h-1.2l-1.085-1.843L10.768 17zm5.014 0v-4.87h1.046v3.939h2.144V17zm3.707-.174v-.931a4.222 4.222 0 0 0 1.48.288c.282 0 .503-.047.664-.141s.241-.223.241-.389a.345.345 0 0 0-.154-.288c-.103-.08-.302-.17-.596-.268l-.51-.174c-.415-.143-.719-.326-.91-.55-.188-.227-.282-.517-.282-.87 0-.304.076-.565.228-.784.156-.22.375-.387.656-.503.282-.12.617-.18 1.005-.18.246 0 .487.024.724.073.241.045.451.107.63.188v.93a3.874 3.874 0 0 0-.697-.2 3.249 3.249 0 0 0-.657-.074c-.554 0-.83.163-.83.49 0 .124.05.227.154.307.107.076.306.163.596.262l.51.174c.437.152.747.337.93.556.184.214.275.507.275.878 0 .455-.163.815-.489 1.079-.322.263-.777.395-1.367.395a5.717 5.717 0 0 1-1.179-.128 1.934 1.934 0 0 1-.422-.14zm-15.863.648L1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileXlsShortcut as FileXlsShortcut };
